import { cmsApiClient } from '@/config/httpClients';
import {
  AdditionalFieldSchema,
  FieldArraySchema,
  SubmitMethodSchema,
  SubmitToSchema,
  type CMSFormResponse,
} from './schema';
import type { DynamicForm } from '@/utils/forms';
import { parseDynamicForm } from '@/utils/forms';

const getCMSForm = async (handle: string): Promise<DynamicForm> => {
  const response = await cmsApiClient
    .get<CMSFormResponse>(`forms/${handle}`)
    .json();

  const { meta, formFields } = parseDynamicForm(response.data);

  const parsedFormFields = FieldArraySchema.safeParse(formFields);
  const parsedSubmitTo = SubmitToSchema.safeParse(meta.submitButton);
  const parsedMethod = SubmitMethodSchema.safeParse(meta.method);
  const parsedAdditionalField = AdditionalFieldSchema.safeParse(
    meta.addititionalField
  );
  if (
    !parsedFormFields.success ||
    !parsedSubmitTo.success ||
    !parsedMethod.success ||
    !parsedAdditionalField.success
  ) {
    // TODO: log to sentry
    console.error('error(parsing getCMSForm)');
  }

  return { meta, formFields };
};

export { getCMSForm };
